import {createSelector} from 'reselect';
import props from '../../../../props';

export default createSelector(
    props.wallet.methods.googlepay_deposit,
    (googlepay_deposit) => {
        return {
            props: googlepay_deposit[googlepay_deposit.stage]
        }
    }
)